import Tooltip from 'components/@extended/Tooltip';
import { useRef, useState, useEffect } from 'react';

const OverflowText = ({ value }: { value: any }) => {
  const textElementRef = useRef<HTMLSpanElement>(null);

  const checkOverflow = () => {
    if (!textElementRef.current) {
      return;
    }
    // Using getBoundingClientRect, instead of scrollWidth and clientWidth, to get width with fractional accuracy
    const clientWidth = textElementRef.current.getBoundingClientRect().width;

    textElementRef.current.style.overflow = 'visible';
    const contentWidth = textElementRef.current?.getBoundingClientRect().width;
    textElementRef.current.style.overflow = 'hidden';

    setIsOverflow(contentWidth > clientWidth);
  };

  useEffect(() => {
    checkOverflow();
    window.addEventListener('resize', checkOverflow);
    return () => {
      window.removeEventListener('resize', checkOverflow);
    };
  }, []);

  const [isOverflowed, setIsOverflow] = useState(false);

  return (
    <Tooltip title={value} disableHoverListener={!isOverflowed}>
      <span
        ref={textElementRef}
        style={{
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis'
        }}
      >
        {value}
      </span>
    </Tooltip>
  );
};
export default OverflowText;
